export const EnforceOfficeDashboardV2 = 'ARF-881-enforce-office-dashboard-v2';
export const EnforcePaymentHistoryTable = 'ARF-949-enforce-update-payment-history-table';
export const EnforcePaymentInvoiceV2 = 'ARF-1255-enforce-payment-invoice-v2';
export const EnforceShiftsOverviewV2 = 'enforce-shifts-overview-v2';
